import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CALLER_HANDLED_STATUSES } from '../../../config/caller-handled-statuses';
import { BlockPage } from './julia-block.model';

export type BlockSort = [string, 'asc' | 'desc'];

/** A block that expired (410) or is unknown (404) is shown by the block itself, without the global error toast. */
const SHOWN_BY_THE_BLOCK = () => new HttpContext().set(CALLER_HANDLED_STATUSES, [404, 410]);

/** The blocks Julia showed in a conversation, read again: a page of rows (another sort, a record's list), or the
 * `.xlsx` export in the sort shown. */
@Injectable({ providedIn: 'root' })
export class JuliaBlocksService {

  constructor(private http: HttpClient) {}

  rows(sessionId: string, blockId: string, page: number, size: number, sort: BlockSort | null,
       child?: string): Observable<BlockPage> {
    let params = this.sorted(new HttpParams().set('page', page).set('size', size), sort);
    if (child) params = params.set('child', child);
    return this.http.get<BlockPage>(this.url(sessionId, blockId, 'rows'), { params, context: SHOWN_BY_THE_BLOCK() });
  }

  export(sessionId: string, blockId: string, sort: BlockSort | null): Observable<HttpResponse<Blob>> {
    return this.http.get(this.url(sessionId, blockId, 'export'),
      { params: this.sorted(new HttpParams(), sort), responseType: 'blob', observe: 'response',
        context: SHOWN_BY_THE_BLOCK() });
  }

  private sorted(params: HttpParams, sort: BlockSort | null): HttpParams {
    return sort ? params.set('sort', `${sort[0]}:${sort[1]}`) : params;
  }

  private url(sessionId: string, blockId: string, action: string): string {
    return `${environment.juliaApiUrl}/api/v1/session/${encodeURIComponent(sessionId)}/blocks/`
      + `${encodeURIComponent(blockId)}/${action}`;
  }
}
